import React from 'react';
import { Col, Form, Layout, notification, Row, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { SiteBranding } from 'parts';
import { Button, Input } from 'components';
import { postPasswordReset } from 'fetcher/signin';
import { ReactComponent as IconBack } from 'static/icons/arrow_left.svg';
import './style.scss';

export const PasswordReset: React.FC = () => {
  const [form] = Form.useForm();

  const onSubmit = (values: any) => {
    postPasswordReset(values)
      .then(() => {
        notification.success({ message: 'Recovery password sent. Check your inbox.' });
      })
      .catch((err) => {
        notification.error({ message: 'Something went wrong.' });
        console.log('error:', err);
      });
  };

  return (
    <div className="page-password-reset">
      <Layout className="page-password-reset__content">
        <Row>
          <Col lg={{ flex: '304px' }} md={{ flex: '100%' }} span={24}>
            <SiteBranding />
          </Col>
          <Col className="form-block" lg={{ flex: '1' }} span={24}>
            <Row className="form-block__header">
              <Col span={24}>
                <Typography.Title level={3}>Forgot password?</Typography.Title>
              </Col>
              <Col span={24}>
                <Typography.Text>We will send you a new one</Typography.Text>
              </Col>
            </Row>
            <Form form={form} onFinish={onSubmit} validateTrigger="onBlur" className="form-block__content">
              <Row>
                <Col span={24}>
                  <Input
                    label="Email"
                    name="email"
                    rules={[
                      { required: true, message: 'Enter email' },
                      { type: 'email', message: 'Invalid email format' },
                    ]}
                    formItemProps={{
                      normalize: (value) => value.replace(/[^a-zA-Z0-9@._%+-]/g, ''),
                    }}
                  />
                </Col>
              </Row>
              <Row gutter={8} justify="end" className="form-block__footer">
                <Col>
                  <Link to="/sign-in">
                    <Button size="large" type="default" icon={<IconBack />}>
                      Back to Sign in
                    </Button>
                  </Link>
                </Col>
                <Col>
                  <Button size="large" htmlType="submit">
                    Send
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Layout>
    </div>
  );
};
